var _path, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVendor = function SvgVendor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "coffee-shop",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18956",
    "data-name": "Path 18956",
    d: "M15.888,2.255l-1-2A.469.469,0,0,0,14.467,0H1.757a.469.469,0,0,0-.414.249L.271,2.265a2.847,2.847,0,0,0-.185.743,1.589,1.589,0,0,0,1.6,1.579,1.589,1.589,0,0,0,1.6-1.579,1.6,1.6,0,0,0,3.2,0,1.6,1.6,0,0,0,3.2,0,1.6,1.6,0,0,0,3.2,0,1.6,1.6,0,0,0,3.2,0,1.556,1.556,0,0,0-.193-.753Z",
    transform: "translate(-0.083 0)",
    fill: "#adafb3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11475",
    "data-name": "Group 11475",
    transform: "translate(0 4.959)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18957",
    "data-name": "Path 18957",
    d: "M251.524,243.768a1.339,1.339,0,0,0-.2.754,1.562,1.562,0,0,0,.5,1.152,2.492,2.492,0,0,1,0,3.515c-.088.1-.168.2-.238.3a1.774,1.774,0,0,0,1.246-.78,3.739,3.739,0,0,0,0-4.154A1.748,1.748,0,0,0,251.524,243.768Z",
    transform: "translate(-243.471 -241.11)",
    fill: "#adafb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18958",
    "data-name": "Path 18958",
    d: "M15.567,168.837h-.514v-9.661A2.549,2.549,0,0,1,12.8,158.7a2.548,2.548,0,0,1-3.2,0,2.548,2.548,0,0,1-3.2,0,2.548,2.548,0,0,1-3.2,0,2.549,2.549,0,0,1-2.255.479v9.661H.433A.433.433,0,0,0,0,169.27a.469.469,0,0,0,.469.469H15.531A.469.469,0,0,0,16,169.27.433.433,0,0,0,15.567,168.837Zm-5.447-1.985A2.639,2.639,0,0,1,8,168.018H8a2.639,2.639,0,0,1-2.12-1.166,4.671,4.671,0,0,1,0-5.269A2.639,2.639,0,0,1,8,160.417H8a2.639,2.639,0,0,1,2.12,1.166,4.671,4.671,0,0,1,0,5.269Z",
    transform: "translate(0 -158.698)",
    fill: "#adafb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18959",
    "data-name": "Path 18959",
    d: "M193.759,260.156a2.48,2.48,0,0,1-.725-1.758,2.712,2.712,0,0,1,.017-.306,2.367,2.367,0,0,0-.3.336,3.739,3.739,0,0,0,0,4.154,2.175,2.175,0,0,0,.543.526,3.587,3.587,0,0,1,.466-.648,1.57,1.57,0,0,0,0-2.3Z",
    transform: "translate(-186.117 -254.986)",
    fill: "#adafb3"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVendor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vendor.e9563679.svg";
export { ForwardRef as ReactComponent };